export function ToPx(rem) {
  return `${
    rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
  }px`
}

export function ToRem(px) {
  return `${
    px / parseInt(getComputedStyle(document.documentElement).fontSize)
  }rem`
}
